import React from 'react'
import axios from 'axios'
import {useParams} from 'react-router-dom'
import { useEffect } from 'react'
import { useState } from 'react'
import Spinner from './spinner/Spinner'
import { useDispatch } from 'react-redux'
import { selectProduct } from '../redux/actions/productAction'
import LeDetail from './LeDetail'




const ProduitDetail = () => {
    const {id} = useParams()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true) 


    const fetchProduitDetail = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`https://fakestoreapi.com/products/${id}`)
            console.log(response.data)
            // envoyer le detail de produit au store
            dispatch(selectProduct(response.data))
        } catch (error) {
            console.log(error)
        }
        setLoading(false);
    }

    useEffect(() => {
        if (id && id !== ''){
            fetchProduitDetail();
        }
    }, [id])
    


  return (
    <div>
        {loading ? <Spinner /> : <LeDetail />}
    </div>
  )
}

export default ProduitDetail